// extracted by mini-css-extract-plugin
export default {"sparkleContainer":"Sparkles_sparkleContainer__pqqMM","particle":"Sparkles_particle__Ibc9v","sparkle":"Sparkles_sparkle__zeriw"};